//закрытие попапа
function popupMenuClose() {
    document.querySelectorAll('.popup').forEach((el) => {
        el.style.display="none";
        const formEl = el.querySelector('form');
        const eventPopup = document.querySelector('.popup_event');

        if (eventPopup) {
            document.body.classList.remove('_event-popup-open');
        }

        if (formEl) {
            formEl.reset();
            formEl.removeAttribute('data-reach-goal-ctx');
        }
        document.body.classList.remove('oc-hidden');

        if(el.querySelector('form input[name="_complex"]')) {
            el.querySelector('form input[name="_complex"]').remove()
        }
        if(el.querySelector('form input[name="title"]')) {
            el.querySelector('form input[name="title"]').remove()
        }
        if(el.querySelector('form input[name="_object"]')) {
            el.querySelector('form input[name="_object"]').remove()
        }


    })
}
document.querySelectorAll('.popup__close').forEach((el) => {
    el.addEventListener('click', function  popupClose(event) {
        popupMenuClose();
    })
})
document.querySelectorAll('.popup').forEach((el) => {
    el.addEventListener('click', function  popupClose(event) {
        if (event.target.closest('.popup__content') ) {
            // клик внутри элемента
            return;
        }
        popupMenuClose();
    })
})

//открытие попапа
$(document).on('click tap', '.popup-link', function(event) {
    event.preventDefault();
    let id = event.currentTarget.getAttribute('data-link');
    let title = event.currentTarget.getAttribute('data-title');
    let object = event.currentTarget.getAttribute('data-object');
    let complex = event.currentTarget.getAttribute('data-complex');
    let sFormInputTpl = null;
    let form = document.querySelector('.popup[id="'+id+'"] form');
    let popupReachGoal = event.currentTarget.getAttribute('data-popup-reach-goal');

    if(title) {
        if(!document.querySelector('.popup[id="'+id+'"] input[name="title"]')) {
            sFormInputTpl = document.createElement("input");
            sFormInputTpl.name = "title";
            sFormInputTpl.type = "hidden";
            sFormInputTpl.value = title;
            document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
        }
        else {
            document.querySelector('.popup[id="'+id+'"] input[name="title"]').value = title;
        }
    }
    if(object) {
        if(!document.querySelector('.popup[id="'+id+'"] input[name="_object"]')) {
            sFormInputTpl = document.createElement("input");
            sFormInputTpl.name = "_object";
            sFormInputTpl.type = "hidden";
            sFormInputTpl.value = object;
            document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
        }
        else {
            document.querySelector('.popup[id="'+id+'"] input[name="_object"]').value = object;
        }
    }
    if(complex) {
        if(!document.querySelector('.popup[id="'+id+'"] input[name="_complex"]')) {
            sFormInputTpl = document.createElement("input");
            sFormInputTpl.name = "_complex";
            sFormInputTpl.type = "hidden";
            sFormInputTpl.value = complex;
            document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
        }
        else {
            document.querySelector('.popup[id="'+id+'"] input[name="_complex"]').value = complex;
        }
    }
    if (popupReachGoal && form) {
        form.setAttribute('data-reach-goal-ctx', popupReachGoal);
    }
    document.querySelector('.popup[id="'+id+'"]').style.display="flex";
    document.body.classList.add('oc-hidden');

    if (id == 'popup-event') {
        const eventHeader = document.querySelector('.event-header');
        document.body.style.setProperty('--event-header-height', eventHeader.clientHeight + 'px');
        document.body.classList.add('_event-popup-open');
        document.querySelector('.popup[id="'+id+'"]').style.display="grid";
    }
});

/*
document.querySelectorAll('.popup-link').forEach((el) => {
    el.addEventListener('click', function  popupOpen(event) {
        event.preventDefault();
        let id = event.currentTarget.getAttribute('data-link');
        let title = event.currentTarget.getAttribute('data-title');
        let object = event.currentTarget.getAttribute('data-object');
        let complex = event.currentTarget.getAttribute('data-complex');
        let sFormInputTpl = null;
        let form = document.querySelector('.popup[id="'+id+'"] form');
        let popupReachGoal = event.currentTarget.getAttribute('data-popup-reach-goal');

        if(title) {
            if(!document.querySelector('.popup[id="'+id+'"] input[name="title"]')) {
                sFormInputTpl = document.createElement("input");
                sFormInputTpl.name = "title";
                sFormInputTpl.type = "hidden";
                sFormInputTpl.value = title;
                document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
            }
            else {
                document.querySelector('.popup[id="'+id+'"] input[name="title"]').value = title;
            }
        }
        if(object) {
            if(!document.querySelector('.popup[id="'+id+'"] input[name="_object"]')) {
                sFormInputTpl = document.createElement("input");
                sFormInputTpl.name = "_object";
                sFormInputTpl.type = "hidden";
                sFormInputTpl.value = object;
                document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
            }
            else {
                document.querySelector('.popup[id="'+id+'"] input[name="_object"]').value = object;
            }
        }
        if(complex) {
            if(!document.querySelector('.popup[id="'+id+'"] input[name="_complex"]')) {
                sFormInputTpl = document.createElement("input");
                sFormInputTpl.name = "_complex";
                sFormInputTpl.type = "hidden";
                sFormInputTpl.value = complex;
                document.querySelector('.popup[id="'+id+'"] form').appendChild(sFormInputTpl)
            }
            else {
                document.querySelector('.popup[id="'+id+'"] input[name="_complex"]').value = complex;
            }
        }
        if (popupReachGoal && form) {
            form.setAttribute('data-reach-goal-ctx', popupReachGoal);
        }
        document.querySelector('.popup[id="'+id+'"]').style.display="flex";
        document.body.classList.add('oc-hidden');

        if (id == 'popup-event') {
            const eventHeader = document.querySelector('.event-header');
            document.body.style.setProperty('--event-header-height', eventHeader.clientHeight + 'px');
            document.body.classList.add('_event-popup-open');
            document.querySelector('.popup[id="'+id+'"]').style.display="grid";
        }
    })
})
*/
document.addEventListener('click', (e) => {
    if (e.target.closest('.event-header__button-close')) {
        popupMenuClose();
    }
})
